import { useFormik } from "formik";
import React, { useEffect, useMemo, useState } from "react";
import { _ as GridRender } from "gridjs-react";
import { Button } from "react-bootstrap";
import ActionDropDown from "./ActionDropDown";
import DataGrid from "./DataGrid";
import "../../styles/components/Admin/AshaDetails.scss";
import ActiveInactive from "./ActiveInactive";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { PAGE } from "../../constants/page";
import { updateBreadcrum } from "../../redux/reducers/BreadcrumbSlice";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import AdminPopUp from "./AdminPopUp";
import { API } from "../../constants/api";
import {
  ApiCallWithLoader,
  errorUpdate,
} from "../../redux/reducers/LoaderSlice";
import { selectedStatePractioner } from "../../redux/reducers/PractionerRoleIdsSlice";
import Utility from "../../utility/Utility";
import Locations from "../../utility/Locations";
import Pagination from "../Pagination";
import { Trans } from "react-i18next";
import { UserState, hideSuccessMessage } from "../../redux/reducers/UserSlice";
import i18next from "i18next";
import SuccessMessage from "../SuccessMessage";
import { PersistState } from "../../redux/reducers/PersistSlice";
import ErrorBoundaryHandler from "../ErrorBoundaryHandler";
import { ROLE } from "../../constants/role";
import AdminSearch from "./AdminSearch";
import LeydenSelect from "../LeydenSelect";
import { SORT_LIST_ADMIN, STATUS_LIST_ADMIN } from "src/constants/options";
import NameEllipses from "./NameEllipses";
import {
  ashaAuthIdState,
  updatedAsha,
  viewSuccessBannerOnDetils,
} from "src/redux/reducers/AuthAshaDetailsSlice";
import { UserConfigState } from "src/redux/reducers/UserConfigSlice";
import LeydenBanner from "../LeydenBanner";

function AshasDetails(props: any) {
  const dispatch = useAppDispatch();
  const [searchAsha, setSearchAsha] = useState<any>([]);
  const [pop, setPopUp] = useState(false);
  const [ashaValue, setAshaValue] = useState<any>({});
  const [deactivate, setDeactivate] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [districts, setDistricts] = useState<any>(null);
  const [statusValue, setStatusValue] = useState("");
  const [searched, setSearched] = useState(false);
  const [resetSelect, setResetSelect] = useState(false);
  const [totalResults, setTotalResults] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const selectedState = useAppSelector(selectedStatePractioner);
  const [cities, setCities] = useState<any>(null);
  const ashaState: any = useAppSelector(ashaAuthIdState);
  const userConfigDetails: any = useAppSelector(UserConfigState);
  const [districtValue, setDistrictValue] = useState<any>();

  const handlePopUp = (value: boolean) => {
    setPopUp(value);
  };
  const userDetails: any = useAppSelector(UserState);
  const userRole = Utility.getUserRole(
    userDetails?.userDetails?.app_metadata?.organizations?.EODB?.groups[0]
  );

  const userSelectedLanguage: any = useAppSelector(PersistState);
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = useParams();
  const stateName: string =
    state?.replace(/%20/g, " ") ||
    userDetails?.userDetails?.user_metadata?.address?.region;

  const getPractitionerIdFromLocationId = async (locationID: any) => {
    try {
      const roleRequest_url = `${API.PRACTITIONER_ROLES}&location=Location/${locationID}`;
      const requestDetails = {
        url: roleRequest_url,
        method: "GET",
      };
      const practionerRoleResp = await dispatch(
        ApiCallWithLoader(requestDetails)
      );
      return practionerRoleResp.payload.entry[0].resource.id;
    } catch (error) {
      console.log(error);
      dispatch(errorUpdate({ isError: true, error: error }));
    }
  };

  const fetchAshas = async (
    pageNumber: number,
    statePractitionerID: string,
    districtLocationId = "",
    villageLocationId = "",
    status = "",
    searchText = "",
    sortValue = "name",
    sortType = "asc"
  ) => {
    let sortTypeConvert;
    if (sortValue === "created_at") {
      sortTypeConvert = sortType === "asc" ? "-1" : "1";
    } else {
      sortTypeConvert = sortType === "asc" ? "1" : "-1";
    }
    let _districtPractitionerId: any = "";
    if (districtLocationId && districtLocationId !== "All") {
      _districtPractitionerId = await getPractitionerIdFromLocationId(
        districtLocationId
      );
    }
    let _villagePractitionerId: any = "";

    if (villageLocationId && villageLocationId !== "All") {
      _villagePractitionerId = await getPractitionerIdFromLocationId(
        villageLocationId
      );
    }
    const _requestData = {
      roles: "Asha",
      statePractitionerId: statePractitionerID,
      districtPractitionerId: _districtPractitionerId,
      villagePractitionerId: _villagePractitionerId,
      status: status,
      searchText,
      per_page: 10,
      page: pageNumber,
      include_totals: true,
      sortQuery: `${sortValue}:${sortTypeConvert}`,
    };

    if (!statePractitionerID) {
      setTotalResults(0);
      setSearchAsha([]);
      return;
    }
    const requestDetails = {
      url: `${API.USERS_BY_ROLES}`,
      method: "POST",
      requestData: _requestData,
      callType: "auth0",
    };
    try {
      const resp = await dispatch(ApiCallWithLoader(requestDetails));
      setSearchAsha(resp?.payload.users || []);
      if (pageNumber === 0) {
        setTotalResults(resp?.payload.total || 0);
      }
    } catch (error) {
      dispatch(errorUpdate({ isError: true, error: error }));
    }
  };
  const handleDeactivateUser = async () => {
    try {
      const requestDetails = {
        url: API.USER_CHANGE_STATUS,
        method: "POST",
        callType: "auth0",
        requestData: {
          user_id: ashaValue.userID,
          status: statusValue === "Deactivate" ? "block" : "unblock",
        },
      };
      setShowAlert(false);
      const resp = await dispatch(ApiCallWithLoader(requestDetails));
      if (resp) {
        setDeactivate(true);
        setShowAlert(true);
        setPopUp(false);
        const updatedList = searchAsha.map((ashaDetails: any) => {
          if (ashaDetails.user_id === ashaValue.userID) {
            ashaDetails.blocked = statusValue === "Deactivate" ? true : false;
          }
          return ashaDetails;
        });
        setSearchAsha([...updatedList]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDistricts = async () => {
    return new Promise<void>(async (resolve, reject) => {
      const requestDetails = {
        url: API.DISTRICTS_BY_STATE.replace(":stateName", stateName),
        method: "GET",
      };
      try {
        const resp = await dispatch(ApiCallWithLoader(requestDetails));
        setDistricts(
          resp.payload?.entry?.map((location: any) => {
            return {
              label: location.resource.name,
              value: location.resource.id,
            };
          })
        );
        resolve(resp.payload);
      } catch (error) {
        dispatch(errorUpdate({ isError: true, error: error }));
        reject(error);
      }
    });
  };

  useEffect(() => {
    if (selectedState?.stateId) {
      setPageNumber(1);
      setCities([]);
      setSearched(false);
      setResetSelect(!resetSelect);

      formik.setFieldValue("searchInput", "");
      formik.setFieldValue("district", "All");
      formik.setFieldValue("status", "All");
      formik.setFieldValue("cityVillageLabel", "All");
      formik.setFieldValue("cityVillageLocationId", "All");
      formik.setFieldValue("districtLocationId", "All");
      formik.setFieldValue("districtLabel", "All");

      fetchDistricts().then(async () => {
        let locationID;
        if (props.stateAdmin) {
          const requestDetails = {
            url: API.STATE_COUNT + `&name=${stateName}`,
            method: "GET",
          };
          const stateLocationResp = await dispatch(
            ApiCallWithLoader(requestDetails)
          );
          locationID = stateLocationResp?.payload.entry[0].resource.id;
        } else {
          locationID = selectedState?.stateId?.value || selectedState.stateId;
        }
        const statePractitionerId = await getPractitionerIdFromLocationId(
          locationID
        );
        formik.setFieldValue("statePractitionerId", statePractitionerId);
        fetchAshas(0, statePractitionerId);
      });
    }
  }, [selectedState]);

  useEffect(() => {
    dispatch(viewSuccessBannerOnDetils(false));
  }, []);

  const dispatchBreadcrumb = () => {
    const breadcrumRedirectUrl =
      location.pathname.indexOf("stateAdmin") === -1
        ? PAGE.GLOBAL_STATE_ADMIN.replace(":state", state || "")
        : PAGE.STATE_ADMIN;
    dispatch(
      updateBreadcrum({
        routeHistory: [
          {
            label: "ASHA",
            label_key: "asha",
            path: `${breadcrumRedirectUrl}/asha`,
            id: `asha_state_${stateName}`,
            value: "",
          },
        ],
        display: true,
      })
    );
  };
  const navigateToDetails = (routeEndValue: string) => {
    dispatchBreadcrumb();
    const routeLink = PAGE.ADD_USERS.replace(":userId", routeEndValue);
    navigate(routeLink);
    dispatch(updatedAsha({ updated: false }));
  };

  const formik = useFormik({
    initialValues: {
      searchInput: "",
      districtLocationId: "All",
      districtLabel: "",
      status: "All",
      cityVillageLocationId: "All",
      cityVillageLabel: "All",
      sortValue: "name",
      sortType: "asc",
      statePractitionerId: "",
    },
    onSubmit: async (values: any) => {
      setPageNumber(1);
    },
  });

  const handlActionClick = (rowData: any, actionValue: any) => {
    if (actionValue === "viewDetails") {
      dispatchBreadcrumb();
      const routeLink = PAGE.VIEW_USERS.replace(":userType", "asha").replace(
        ":userName",
        rowData?._cells[0].data
      );
      navigate(routeLink, {
        state: {
          authID: rowData._cells[7].data,
          userRole: userRole,
        },
      });
      dispatch(updatedAsha({ updated: false }));
    } else if (actionValue === "deactivate" || actionValue === "activate") {
      dispatch(hideSuccessMessage(false));
      handlePopUp(true);
      setShowAlert(false);
      const statusValue =
        actionValue === "deactivate" ? "Deactivate" : "Activate";
      setStatusValue(statusValue);
      handlePopUp(true);
      setAshaValue({
        name: rowData?._cells[0].data,
        userID: rowData._cells[7].data,
      });
      dispatch(updatedAsha({ updated: false }));
    } else if (actionValue === "editDetails") {
      dispatchBreadcrumb();
      const routeLink = PAGE.UPDATE_ASHA;
      navigate(routeLink, {
        state: { ashaAuthId: rowData._cells[7].data, userRole: userRole },
      });
      dispatch(updatedAsha({ updated: false }));
    }
  };

  const AshaColumn: any[] = [
    {
      id: "name",
      name: i18next.t("grid.asha_name"),
      formatter: (_cell: any, row: any) => {
        const ActionList = row.cells[0].data;
        if (ActionList.length >= 22) {
          return GridRender(
            <NameEllipses
              actionList={ActionList}
              id={row.cells[0]._id}
              toggleName={ActionList}
              tabType="asha"
            />
          );
        } else {
          return ActionList;
        }
      },
    },
    {
      id: "username",
      name: i18next.t("grid.asha_id"),
      data: (cell: any) => {
        return cell?.username?.toUpperCase();
      },
    },
    {
      id: "app_metadata",
      name: i18next.t("grid.phone_number"),
      formatter: (_cell: any, _row: any) => {
        return _cell.phone_number;
      },
    },
    {
      id: "user_metadata",
      name: i18next.t("grid.district"),
      formatter: (_cell: any, _row: any) => {
        return _cell?.address?.locality.split(",")[1] || "";
      },
    },
    {
      id: "user_metadata",
      name: i18next.t("grid.city_village"),
      formatter: (_cell: any, _row: any) => {
        return _cell?.address?.locality.split(",")[0] || "";
      },
    },
    {
      id: "blockedStatus",
      name: i18next.t("grid.status"),
      data: (cell: any) => {
        const app_metaData = cell.app_metadata;
        const statusValue = cell?.blocked ? true : false;
        const blockerFor = cell?.blocked_for;
        const statusData = Utility.getStatusValue(
          statusValue,
          app_metaData,
          blockerFor
        );
        return statusData;
      },
      formatter: (_: any, row: any) => {
        const app_metaData = _?.app_metadata ? _.app_metadata : "";
        const statusValue = row.cells[5].data ? row.cells[5].data : "";
        return GridRender(<ActiveInactive statusValue={statusValue} />);
      },
    },
    {
      id: "email",
      name: "Email",
      hidden: true,
    },
    {
      id: "user_id",
      name: "User ID",
      hidden: true,
    },
    {
      id: "blocked",
      name: "blocked",
      hidden: true,
    },
    {
      id: "action",
      name: i18next.t("grid.action"),
      formatter: (_cell: any, row: any) => {
        const statusValue = row.cells[5].data ? row.cells[5].data : "Inactive";
        let ActionList: any = [
          {
            value: i18next.t("grid.view_details"),
            action: "viewDetails",
          },
        ];
        if (userRole !== ROLE.GLOBAL_ADMIN_SUPPORT) {
          if (statusValue === "Active") {
            ActionList.push({
              value: i18next.t("grid.deactivate"),
              action: "deactivate",
            });
          } else if (statusValue === "Inactive") {
            ActionList.push({
              value: i18next.t("grid.activate"),
              action: "activate",
            });
          }
        }
        if (
          userRole !== "global-admin" &&
          (statusValue === "Active" || "Disabled" || "Not Activated") &&
          statusValue !== "Inactive"
        ) {
          ActionList.push({
            value: i18next.t("grid.edit_details"),
            action: "editDetails",
          });
        }

        return GridRender(
          <ActionDropDown
            actionList={ActionList}
            row={row}
            onActionClick={handlActionClick}
            useLeyden={true}
          />
        );
      },
    },
    {
      id: "blocked_for",
      name: "blocked_for",
      hidden: true,
    },
  ];

  async function getCities(stateName: string, districtName: string) {
    setShowAlert(false);
    setCities([]);

    if (stateName && districtName) {
      const getCitiesCountUrl = API.CITY_VILLAGE_BY_DISTRICTS.replace(
        ":state",
        stateName?.toLowerCase()
      ).replace(":district", districtName?.toLowerCase());
      const countRequestDetails = {
        url: `${getCitiesCountUrl}&_count=1`,
        method: "GET",
      };
      const getCityDataCount = await dispatch(
        ApiCallWithLoader(countRequestDetails)
      );
      const total_count = getCityDataCount?.payload?.total;

      const roleRequest_url = API.CITY_VILLAGE_BY_DISTRICTS.replace(
        ":state",
        stateName?.toLowerCase()
      ).replace(":district", districtName?.toLowerCase());
      const requestDetails = {
        url: `${roleRequest_url}&_count=${total_count}`,
        method: "GET",
      };

      const getCityData = await dispatch(ApiCallWithLoader(requestDetails));

      const cities = await Locations.getCityMapping(
        getCityData?.payload?.entry
      );
      setCities(cities || []);
    }
  }

  async function changeDistrict(selectedDistricts: any) {
    const selectedDistrict = selectedDistricts;
    setDistrictValue(selectedDistrict);
    dispatch(updatedAsha({ updated: false }));
    if (formik.values.districtLabel !== selectedDistrict.label) {
      // Clear the city details when the district changes
      formik.setFieldValue("cityVillageLocationId", "All");
      formik.setFieldValue("cityVillageLabel", "All");
    }
    // Set the district details

    formik.setFieldValue("districtLocationId", selectedDistrict.value);
    formik.setFieldValue("districtLabel", selectedDistrict.label);
    // Populate the cities dropdown

    if (selectedDistrict.value) {
      await getCities(stateName, selectedDistrict.label);
    } else {
      setCities([]);
      formik.setFieldValue("cityVillageLocationId", "All");
      formik.setFieldValue("cityVillageLabel", "All");
    }
  }

  const memoDataGrid = useMemo(() => {
    return <DataGrid columnData={AshaColumn} cellData={searchAsha} />;
  }, [searchAsha, userSelectedLanguage?.language]);

  const handleRemoveSuccessMessage = (e?: any) => {
    setShowAlert(false);
  };

  const handlePageChange = async (e: any) => {
    setShowAlert(false);
    dispatch(updatedAsha({ updated: false }));
    setPageNumber(e.selected + 1);
    await fetchAshas(
      e.selected,
      formik.values.statePractitionerId,
      formik.values.districtLocationId,
      formik.values.cityVillageLocationId,
      formik.values.status,
      formik.values.searchInput,
      formik.values.sortValue,
      formik.values.sortType
    );
  };
  const onInput = async (searchText: any) => {
    if (searchText.length === 0) {
      handleRemoveSuccessMessage();
      setPageNumber(1);
      formik.setFieldValue("searchInput", "");
      await fetchAshas(
        0,
        formik.values.statePractitionerId,
        formik.values.districtLocationId,
        formik.values.cityVillageLocationId,
        formik.values.status,
        "",
        formik.values.sortValue,
        formik.values.sortType
      );
    }
  };
  const onSearch = async (searchText: string) => {
    handleRemoveSuccessMessage();
    dispatch(updatedAsha({ updated: false }));
    setPageNumber(1);
    formik.setFieldValue("searchInput", searchText);
    await fetchAshas(
      0,
      formik.values.statePractitionerId,
      formik.values.districtLocationId,
      formik.values.cityVillageLocationId,
      formik.values.status,
      searchText,
      formik.values.sortValue,
      formik.values.sortType
    );
  };
  const sortDropDownChange = async (sort: any) => {
    setPageNumber(1);
    handleRemoveSuccessMessage();
    dispatch(updatedAsha({ updated: false }));
    let sortFinalValue = sort?.value ? sort?.value : "name";
    formik.setFieldValue("sortValue", sortFinalValue);
    await fetchAshas(
      0,
      formik.values.statePractitionerId,
      formik.values.districtLocationId,
      formik.values.cityVillageLocationId,
      formik.values.status,
      formik.values.searchInput,
      sortFinalValue,
      formik.values.sortType
    );
  };
  const onSortIconCLick = async () => {
    handleRemoveSuccessMessage();
    dispatch(updatedAsha({ updated: false }));
    setPageNumber(1);
    const finalSortValue = formik.values.sortType === "asc" ? "dec" : "asc";
    formik.setFieldValue("sortType", finalSortValue);
    await fetchAshas(
      0,
      formik.values.statePractitionerId,
      formik.values.districtLocationId,
      formik.values.cityVillageLocationId,
      formik.values.status,
      formik.values.searchInput,
      formik.values.sortValue,
      finalSortValue
    );
  };
  const applyFilter = async () => {
    handleRemoveSuccessMessage();
    setPageNumber(1);
    await fetchAshas(
      0,
      formik.values.statePractitionerId,
      formik.values.districtLocationId,
      formik.values.cityVillageLocationId,
      formik.values.status,
      formik.values.searchInput,
      formik.values.sortValue,
      formik.values.sortType
    );
    dispatch(updatedAsha({ updated: false }));
  };
  return (
    <div className="container">
      <div className="ashaDetails">
        <AdminSearch
          placeholderKey="placeholder.search_asha"
          onSearch={onSearch}
          onInput={onInput}
        />
        <div className="applyContainer">
          <LeydenSelect
            label={"Select District"}
            label_key="select_district"
            options={Utility.getOptions(districts ? districts : [])}
            onChange={(district: any) => {
              changeDistrict(district);
            }}
            id={"districtList"}
            defaultSelected={formik.values.districtLocationId}
            error={formik.errors.districtLocationId}
            mandate={false}
            blankOptionLabel={"All"}
          />
          <LeydenSelect
            label={"City/Town/Village"}
            label_key="city_village"
            options={Utility.getOptions(cities ? cities : [])}
            onChange={(cities: any) => {
              formik.setFieldValue("cityVillageLocationId", cities?.value);
              formik.setFieldValue("cityVillageLabel", cities?.label);
            }}
            id={"cityVillage"}
            defaultSelected={formik.values.cityVillageLocationId}
            error={formik.errors.cityVillageLocationId}
            mandate={false}
            blankOptionLabel={"All"}
          />
          <LeydenSelect
            label={"Select Status"}
            label_key="select_status"
            options={Utility.getOptions(STATUS_LIST_ADMIN)}
            onChange={(status: any) => {
              formik.setFieldValue("status", status?.value);
            }}
            id={"status"}
            defaultSelected={formik.values.status}
            error={formik.errors.status}
            mandate={false}
            blankOptionLabel={"All"}
          />
          <Button
            className="btn-outline apply_filter_admin"
            onClick={applyFilter}
            data-testid="applyFilter_asha"
          >
            <Trans i18nKey={"apply_filter"} />
          </Button>
        </div>
      </div>
      {deactivate === true &&
      showAlert &&
      userDetails.successMessage === false ? (
        <SuccessMessage
          ashaActivateDectivate={ashaValue.name}
          statusVal={
            statusValue.toLocaleLowerCase() === "activate"
              ? "activated"
              : "deactivated"
          }
          onIconClose={() => {
            setShowAlert(false);
          }}
          page="ashaDetails"
        />
      ) : null}
      <div className="mt-3">
        {ashaState?.updatedAsha?.updated === true ? (
          <LeydenBanner
            children="Profile has been updated successfully"
            onIconClose={() => {
              setShowAlert(false);
            }}
          />
        ) : null}
      </div>
      <AdminPopUp
        show={pop}
        handelClose={() => {
          handlePopUp(false);
        }}
        handleOnSubmit={() => handleDeactivateUser()}
        title_key={`${statusValue}_user`}
        body={
          <>
            <Trans i18nKey={"are_you_sure_you_want"} />{" "}
            <span className="text-capitalize">
              <Trans i18nKey={statusValue?.toLowerCase()} />
            </span>{" "}
            <b>{ashaValue.name}</b>?
          </>
        }
        primaryButtonTitle_key={statusValue}
        secondaryButtonTitle_key="cancel"
      />
      <div
        className={
          deactivate === true &&
          showAlert &&
          userDetails.successMessage === false
            ? "successMarginTopAsha listSortAshaDetails"
            : "listSortAshaDetails"
        }
      >
        <h3>
          <Trans i18nKey={"list_of_asha_in"} />{" "}
          <span className="text-caps">{stateName}</span>
        </h3>
        <div className="asha_sort_add">
          <span className="adminSortTitle">
            <Trans i18nKey={"sort_by"} />
          </span>
          <LeydenSelect
            label={" "}
            options={Utility.getOptions(SORT_LIST_ADMIN)}
            onChange={sortDropDownChange}
            id={"sort_asha"}
            defaultSelected={formik.values.sortValue}
            error={formik.errors.sortValue}
            mandate={false}
            blankOptionLabel={"name"}
            isLabelInline={true}
          />
          <img
            src="/icons/SortAsc.svg"
            alt="sort_icon"
            onClick={onSortIconCLick}
            className={
              formik.values.sortType === "asc"
                ? "admin-asc-img"
                : "admin-dec-img"
            }
          />
          {props.stateAdmin == true &&
          userConfigDetails?.availableRoles?.includes(ROLE.ASHA) ? (
            <>
              <img
                src="/icons/DividerAdmin.svg"
                alt="divider_icon"
                className="divider_admin"
              />
              <Button
                data-testid="addAsha"
                type="button"
                className="addAdminsBtn"
                onClick={() => navigateToDetails("asha")}
              >
                <Trans i18nKey={"add_asha"} />
              </Button>
            </>
          ) : (
            <div className="noAddButton"></div>
          )}
        </div>
      </div>
      <div>{memoDataGrid}</div>
      <div className="mt-2" style={{ marginBottom: "150px" }}>
        {totalResults > 0 && (
          <Pagination
            totalResultsFound={totalResults}
            pageNumber={pageNumber}
            pageCount={Math.ceil(totalResults / 10)}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </div>
  );
}

export default ErrorBoundaryHandler(AshasDetails);
